module.exports = __webpack_public_path__ + "images/dropbox-mark-subtle.42567434cf318b8478e6.svg";